import { Button, Divider, Paper, Typography } from "@mui/material";
import {
  cancelBoundaryEditActivePoint,
  setBoundaryEditActivePoint,
  setBoundaryEditPoints,
} from "portal/state/farmExplorer";
import { roundToNPlaces } from "common/utils/numbers";
import { useDispatch } from "react-redux";
import { useFarmExplorer } from "portal/state/store";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { FC } from "react";

const LAT_LON_DECIMALS = 6;

export const BoundaryPointCard: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { boundaryEdit } = useFarmExplorer();

  const points = boundaryEdit?.points ?? [];
  const point = points.find((pt) => pt.pointId === boundaryEdit?.activePointId);
  if (!point) {
    return;
  }

  const row = (label: string, value: string): JSX.Element => (
    <div className="flex justify-between gap-6">
      <Typography className="text-xs my-auto">{label}</Typography>
      <Typography className="font-mono text-xs">{value}</Typography>
    </div>
  );

  return (
    <Paper className="m-2 p-3 flex flex-col gap-1 w-64">
      <Typography className="font-bold">
        {t("views.farms.editBoundary.pointDialogTitle", {
          number: point.ordinal,
        })}
      </Typography>
      {boundaryEdit?.carrying && (
        <Typography className="text-xs">
          {t("views.farms.editBoundary.clickToPlace")}
        </Typography>
      )}
      <Divider className="my-1" />
      {row(
        t("views.farms.editBoundary.longitude"),
        String(roundToNPlaces(point.lng, LAT_LON_DECIMALS))
      )}
      {row(
        t("views.farms.editBoundary.latitude"),
        String(roundToNPlaces(point.lat, LAT_LON_DECIMALS))
      )}
      <div className="flex justify-between gap-6">
        <Typography className="text-xs my-auto">
          {t("utils.descriptors.id")}
        </Typography>
        <Typography className="font-mono text-xs my-auto break-all">
          {point.pointId}
        </Typography>
      </div>
      <div className="flex gap-2 mt-1">
        <Button
          className="grow"
          size="small"
          variant="contained"
          onClick={() => dispatch(setBoundaryEditActivePoint(undefined))}
        >
          {t("utils.actions.done")}
        </Button>
        <Button
          className="grow"
          size="small"
          color="inherit"
          onClick={() => dispatch(cancelBoundaryEditActivePoint())}
        >
          {t("utils.actions.cancel")}
        </Button>
        <Button
          className="grow"
          size="small"
          color="error"
          variant="contained"
          startIcon={<DeleteIcon />}
          onClick={() =>
            dispatch(
              setBoundaryEditPoints(
                points.filter((pt) => pt.pointId !== point.pointId)
              )
            )
          }
        >
          {t("utils.actions.delete")}
        </Button>
      </div>
    </Paper>
  );
};
